import { render, staticRenderFns } from "./GoogleTagManagerRegister.vue?vue&type=template&id=60c5055e&"
import script from "./GoogleTagManagerRegister.vue?vue&type=script&lang=js&"
export * from "./GoogleTagManagerRegister.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports